<template>
    <v-container fuild>
        <v-card flat>
            <v-card-title>Maps
            </v-card-title>
            <v-card-text>
                * To add new map, please contact ARS.
            </v-card-text>
        </v-card>
        <v-card flat>
            <v-card-title>
                <template>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Map" single-line
                                hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </v-card-title>
            <v-data-table :loading="loading" :headers="headers" :items="getMaps" :search="search" item-key="id"
                single-expand sort-by="mapName" sort-desc @click:row="getMap">
                <template v-slot:item.mapName="{ item }">
                    <span>
                        {{ item.mapName }}
                    </span>
                </template>
                <template v-slot:item.speech="{ item }">
                    <span>
                        {{ item.speech }}
                    </span>
                </template>
                <template v-slot:item.mapFloor="{ item }">
                    {{ item.mapFloor }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    {{ item.updated_at | formatDate }}
                </template>
                <template v-slot:item.actions="{ }">
                    -
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: 'mapManagement',
    data() {
        return {
            loading: false,
            search: "",
            height: window.innerHeight,
            headers: [
                { text: 'Map Name', value: 'mapName', align: 'start' },
                { text: 'Speech', value: 'speech' },
                { text: 'Map Floor', value: 'mapFloor', sort: 'asc' },
                { text: 'Updated At', value: 'updated_at', align: 'start' },
                { text: 'Actions', value: 'actions' }
            ],
        }
    },
    computed: {
        ...mapGetters(['getMaps'])
    },
    methods: {
        getMap(item) {
            console.log('Clicked Map', item)
            this.$store.commit('setSelectedMap', item)
            this.$store.commit('setViewMap', true)
        }
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('L')
        },
    },
    mounted() {
        if (this.getMaps.length == 0) {
            this.$store.dispatch("pullMaps")
        }
    },
}
</script>